import e from "./index205.mjs";
import n from "./index212.mjs";
function s(m, r) {
  n(2, arguments);
  var t = e(m).getTime(), i = e(r.start).getTime(), a = e(r.end).getTime();
  if (!(i <= a))
    throw new RangeError("Invalid interval");
  return t >= i && t <= a;
}
export {
  s as default
};
//# sourceMappingURL=index290.mjs.map
